var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.016 18.0264V7.01788H18.0137V18.0264H21.016Z",
    fill: "#E52A30",
    stroke: "#E52A30",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0132 7.0179C14.458 3.73035 12.3969 1.84588 11.8299 1.36351C10.9793 0.639947 10.0185 0.943683 10.0185 2.75409C10.0185 4.5645 12.6521 5.63883 12.6521 7.0179C12.6541 7.02641 9.27092 7.02691 2.50317 7.0194C2.30591 7.01914 2.11053 7.05776 1.9282 7.13305C1.74587 7.20834 1.58017 7.31883 1.44057 7.4582C1.30096 7.59757 1.1902 7.76309 1.1146 7.94529C1.03901 8.12749 1.00007 8.32281 1 8.52007V8.52157C0.999934 8.71901 1.03877 8.91453 1.11428 9.09696C1.18979 9.27939 1.3005 9.44516 1.44009 9.58479C1.57968 9.72443 1.74541 9.8352 1.92781 9.91077C2.11022 9.98634 2.30573 10.0252 2.50317 10.0252H6.01239C6.61586 14.0123 6.94912 16.1805 7.01167 16.5298C7.10574 17.0527 7.60513 18.0265 9.04025 18.0265H18.0132V7.0179Z",
    stroke: "#E52A30",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointing);
export default __webpack_public_path__ + "static/media/pointing.9326cd6ca0fa7f5fa963ad3fcdba73ec.svg";
export { ForwardRef as ReactComponent };